<flx-modal
  [dismissible]="true"
  [title]="customHeader() ? title() : ''"
  [headerClass]="customHeader() ? 'compact-header' : ''"
  (dismiss)="closeModal()"
  class="flx-ds large relative"
>
  @if (customHeader()) {
    <ng-content select="[modalHeader]"></ng-content>
  } @else {
    <div
      [class]="tabs().length ? '' : 'border-b-[0.5px] border-neutral-200'"
      class="flex flex-col gap-2 mb-2 p-1"
    >
      <div
        class="text-base font-bold text-center capitalize"
        data-testid="test-modal-title"
      >
        {{ title() }}
      </div>
      <div class="text-sm text-neutral-500 text-center">
        @if (subtitle()) {
          <ng-container>
            {{ subtitle() }}
          </ng-container>
        } @else {
          <ng-content select="[subtitle]"></ng-content>
        }
      </div>
    </div>
  }

  @if (tabs().length) {
    <flx-tab-bar
      [(selectedTabIndex)]="selectedTabIndex"
      class="grow min-h-0 flx-ds shadowless"
    >
      @for (tab of tabs(); track tab.id) {
        <flx-tab [label]="tab.label">
          <ng-container flxTabContent>
            <div class="h-full">
              @switch (tab.id) {
                @case ('documents') {
                  <ng-content select="[secondaryTab]"></ng-content>
                }
                @default {
                  <ng-container *ngTemplateOutlet="testContent" />
                }
              }
            </div>
          </ng-container>
        </flx-tab>
      }
    </flx-tab-bar>
  } @else {
    <ng-container *ngTemplateOutlet="testContent" />
  }

  <ng-content select="[footer]"></ng-content>
  <div class="absolute bottom-0 left-0 right-0 z-50">
    <ng-content select="[bottomSheet]"></ng-content>
  </div>
</flx-modal>

<ng-template #testContent>
  <as-split
    [useTransition]="true"
    direction="horizontal"
    gutterTransition="all 2s ease"
  >
    <as-split-area
      [size]="sectionSizes().leftSection"
      [minSize]="10"
      class="h-full bg-transparent flex flex-col overflow-hidden"
    >
      <ng-container
        *ngTemplateOutlet="
          header;
          context: {
            title: sections().leftSection.title,
            subtitle: sections().leftSection.subtitle,
          }
        "
      />
      <ng-content select="[leftSection]"></ng-content>
    </as-split-area>
    @if (hasMiddleSection()) {
      <as-split-area
        [size]="sectionSizes().middleSection"
        [minSize]="10"
        class="h-full bg-transparent flex flex-col overflow-hidden"
      >
        @if (sections().middleSection) {
          <ng-container
            *ngTemplateOutlet="
              header;
              context: {
                title: sections().middleSection.title,
                subtitle: sections().middleSection.subtitle,
              }
            "
          />
        }
        <ng-content select="[middleSection]"></ng-content>
      </as-split-area>
    }
    <as-split-area
      [size]="sectionSizes().rightSection"
      [minSize]="10"
      class="h-full bg-transparent flex flex-col overflow-hidden"
    >
      <div class="flex items-start justify-between gap-2">
        <div class="grow min-w-0">
          <ng-container
            *ngTemplateOutlet="
              header;
              context: {
                title: sections().rightSection.title,
                subtitle: sections().rightSection.subtitle,
              }
            "
          />
        </div>
        <ng-content select="[rightSectionAction]"></ng-content>
      </div>
      <ng-content select="[rightSection]"></ng-content>
    </as-split-area>
  </as-split>
</ng-template>

<ng-template
  #header
  let-title="title"
  let-subtitle="subtitle"
>
  <div
    [class.mt-6]="customHeader() && !tabs().length"
    class="flex flex-col gap-1 mb-4"
  >
    <p class="text-sm font-semibold">{{ title }}</p>
    <p class="text-xs text-neutral-500 text-ellipsis overflow-hidden line-clamp-1 min-h-4">
      {{ subtitle }}
    </p>
  </div>
</ng-template>
